/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class PlatformLegalEntityBankAccountDto{

  uuid: string | null = null;

  owner: string | null = null;

  iban: string | null = null;

  currencyCode: string | null = null;

  swiftCode: string | null = null;

  bankName: string | null = null;
}
